"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigPictureClient = exports.Configuration = exports.Service = void 0;
var envelope_1 = require("../model/envelope");
var models_1 = require("../model/models");
var utils_1 = require("../utils");
var Service;
(function (Service) {
    Service["FRESNEL_PROD"] = "https://fresnel-events.vimeocdn.com";
    Service["FRESNEL_PROD_CN"] = "https://fresnel-events.videoji.cn";
    Service["FRESNEL_DEV"] = "https://fresnel-event-staging.vimeows.com";
    // lensflare.vimeo.com is same destination as fresnel-events.vimeocdn.com
    // fresnel-events.vimeocdn.com will still work.
    // Eventually all the apps using this client should move to this new
    // endpoint. Removes 'fresnel' from the name and prevents ad-blockers
    // blocking us. For a while.
    Service["EVENTS_PROD"] = "https://lensflare.vimeo.com";
})(Service = exports.Service || (exports.Service = {}));
var Configuration = /** @class */ (function () {
    function Configuration(service, 
    // TODO: It would be great to remove the `any`s, but I'm pretty sure we'd need
    // existential types, which typescript doesn't have yet.
    // https://github.com/microsoft/TypeScript/issues/14466
    globalBPO, contexts, endpoint) {
        if (globalBPO === void 0) { globalBPO = null; }
        if (contexts === void 0) { contexts = null; }
        if (endpoint === void 0) { endpoint = ''; }
        this.service = service;
        this.globalBPO = globalBPO;
        this.contexts = contexts;
        this.endpoint = endpoint;
    }
    return Configuration;
}());
exports.Configuration = Configuration;
var BigPictureClient = /** @class */ (function () {
    /* eslint-disable-next-line @typescript-eslint/no-empty-function */
    function BigPictureClient() {
    }
    Object.defineProperty(BigPictureClient, "isInitalized", {
        /**
         * @returns `true` If BigPicture Client is intialized with `global` by Client App which is using this library.
         */
        get: function () {
            return Boolean(BigPictureClient.conf.globalBPO);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @summary Convenience method to update the configuration
     * @param configuration
     */
    BigPictureClient.configure = function (configuration) {
        BigPictureClient.conf = configuration;
        // If there are any events been sent prior to configuration, send all now, with provided configuration.
        if (BigPictureClient.WAIT_QUEUE.length > 0) {
            BigPictureClient.WAIT_QUEUE.map(function (item) {
                var event = item.event, contexts = item.contexts;
                if (contexts) {
                    BigPictureClient.sendEventWithContexts(event, contexts);
                }
                else {
                    BigPictureClient.sendEvent(event);
                }
            });
            BigPictureClient.WAIT_QUEUE = [];
        }
    };
    BigPictureClient.updateObject = function (sourceObject, targetObject) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, key, newValue;
            var e_1, _d;
            return __generator(this, function (_e) {
                try {
                    for (_a = __values(Object.entries(sourceObject)), _b = _a.next(); !_b.done; _b = _a.next()) {
                        _c = __read(_b.value, 2), key = _c[0], newValue = _c[1];
                        if (key in targetObject) {
                            if (newValue instanceof Object) {
                                if (targetObject[key] instanceof Object) {
                                    BigPictureClient.updateObject(newValue, targetObject[key]);
                                    return [2 /*return*/];
                                }
                                else {
                                    targetObject[key] = newValue;
                                    return [2 /*return*/];
                                }
                            }
                            else {
                                targetObject[key] = newValue;
                            }
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * @summary Use this to update values that need to change in the target context
     * @param contextToUpdate
     *
     */
    BigPictureClient.updateContext = function (contextToUpdate) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (contextToUpdate.context == 'global' && BigPictureClient.conf.globalBPO) {
                    BigPictureClient.updateObject(contextToUpdate.fields, BigPictureClient.conf.globalBPO.fields);
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * @summary Post/Send an event to the configured BigPicture Edge.
     * @param event
     */
    BigPictureClient.sendEvent = function (event, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            var REQUEST_BODY, REQUEST_EVENT, destination, URL, requestProperties, blob;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // verify required parameter 'envelope' is not null or undefined
                        if (event === null || event === undefined) {
                            throw new Error('Required parameter event was null or undefined when calling sendEvent.');
                        }
                        if (!BigPictureClient.isInitalized) {
                            if (process.env.NODE_ENV !== 'production') {
                                console.warn('[BigPicture] Configure BigPicture Client before sending the Events.');
                            }
                            BigPictureClient.WAIT_QUEUE.push({ event: event });
                            BigPictureClient.waitAndFlushQueue();
                            return [2 /*return*/];
                        }
                        REQUEST_BODY = JSON.stringify(models_1.ObjectSerializer.serialize([new envelope_1.Envelope(event, this.conf.globalBPO)], 'Array<Envelope>'));
                        REQUEST_EVENT = (0, utils_1.formatRequestEvent)(event.name);
                        destination = this.conf.endpoint !== '' ? this.conf.endpoint : this.conf.service;
                        URL = "".concat(destination, "/add/").concat(encodeURIComponent(REQUEST_EVENT));
                        if (!(!navigator.sendBeacon || jwtToken)) return [3 /*break*/, 2];
                        requestProperties = {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'User-Agent': navigator.userAgent,
                                Origin: location.origin,
                                Referer: document.referrer,
                            },
                            body: REQUEST_BODY,
                        };
                        if (jwtToken) {
                            requestProperties.headers.Authorization = jwtToken;
                        }
                        return [4 /*yield*/, fetch(URL, requestProperties)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        blob = new Blob([REQUEST_BODY]);
                        navigator.sendBeacon(URL, blob);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Post/Send an event with one or more contexts
     */
    BigPictureClient.sendEventWithContexts = function (event, contexts, jwtToken) {
        return __awaiter(this, void 0, void 0, function () {
            var envelopeOfEventWithGlobal, serializedEnvelope, _a, _b, _c, contextName, context, serializedContext, REQUEST_BODY, REQUEST_EVENT, destination, URL, requestProperties, blob;
            var e_2, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        // verify required parameter 'envelope' is not null or undefined
                        if (event === null || event === undefined) {
                            throw new Error('Required parameter event was null or undefined when calling sendEvent.');
                        }
                        if (!BigPictureClient.isInitalized) {
                            if (process.env.NODE_ENV !== 'production') {
                                console.warn('[BigPicture] Configure BigPicture Client before sending the Events.');
                            }
                            BigPictureClient.WAIT_QUEUE.push({ event: event, contexts: contexts });
                            BigPictureClient.waitAndFlushQueue();
                            return [2 /*return*/];
                        }
                        envelopeOfEventWithGlobal = new envelope_1.Envelope(event, this.conf.globalBPO);
                        serializedEnvelope = models_1.ObjectSerializer.serialize([envelopeOfEventWithGlobal], 'Array<Envelope>');
                        // Go through each `context`, serialize, and add to the Envelope
                        serializedEnvelope[0]['contexts'] = {};
                        try {
                            for (_a = __values(Object.entries(contexts)), _b = _a.next(); !_b.done; _b = _a.next()) {
                                _c = __read(_b.value, 2), contextName = _c[0], context = _c[1];
                                serializedContext = models_1.ObjectSerializer.serialize(context, 'EventContext');
                                serializedEnvelope[0].contexts[contextName] = serializedContext;
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        REQUEST_BODY = JSON.stringify(serializedEnvelope);
                        REQUEST_EVENT = (0, utils_1.formatRequestEvent)(event.name);
                        destination = this.conf.endpoint !== '' ? this.conf.endpoint : this.conf.service;
                        URL = "".concat(destination, "/add/").concat(encodeURIComponent(REQUEST_EVENT));
                        if (!(!navigator.sendBeacon || jwtToken)) return [3 /*break*/, 2];
                        requestProperties = {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'User-Agent': navigator.userAgent,
                                Origin: location.origin,
                                Referer: document.referrer,
                            },
                            body: REQUEST_BODY,
                        };
                        if (jwtToken) {
                            requestProperties.headers.Authorization = jwtToken;
                        }
                        return [4 /*yield*/, fetch(URL, requestProperties)];
                    case 1:
                        _e.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        blob = new Blob([REQUEST_BODY]);
                        navigator.sendBeacon(URL, blob);
                        _e.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Flush the queue - do this if BigPicture is not properly initialized
     */
    BigPictureClient.waitAndFlushQueue = function () {
        if (!BigPictureClient.flushQueueTimeoutHandler) {
            BigPictureClient.flushQueueTimeoutHandler = setTimeout(function () {
                if (BigPictureClient.WAIT_QUEUE.length > 0) {
                    BigPictureClient.WAIT_QUEUE = [];
                    console.error('[BigPicture] All events are dropped, BigPicture Client must be configured to send events.');
                }
            }, BigPictureClient.FLUSH_QUEUE_TIMEOUT);
        }
    };
    BigPictureClient.FLUSH_QUEUE_TIMEOUT = 10000;
    BigPictureClient.conf = new Configuration(Service.FRESNEL_PROD);
    BigPictureClient.WAIT_QUEUE = [];
    return BigPictureClient;
}());
exports.BigPictureClient = BigPictureClient;
//# sourceMappingURL=bigPictureClient.js.map